export default () => ({
    open: false,
})
